import axios from "axios";
import { useDispatch } from "react-redux";




// console.log(process.env.REACT_APP_API)

// export const url = "https://prasant7878.pythonanywhere.com/";
// export const url = "http://192.168.1.140:8000/";
// export const url ="http://192.168.1.160:8000/"
export const url = "https://api.gmarg.com/";
// export const url = "http://127.0.0.1:8000/";



const api = axios.create({
  baseURL: url,
});

// const api = axios.create({
//   baseURL: url,
// });

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("user"));

    // problem: authentication failed is trying to solve
    if (token) {
      config.headers["Authorization"] = "Bearer " + token.access;
      //   config.headers["Access-Control-Allow-Origin"] = "*";
      //   config.headers["Access-Control-Allow-Credentials"] = "true";
    }
    config.headers["Content-Type"] = "application/json";
    config.headers["accept"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const refreshToken = JSON.parse(localStorage.getItem("user"));
    const originalRequest = error.config;
    if (error.response) {
      if (
        refreshToken?.refresh &&
        error.response.status === 401 &&
        error.response.data.detail === "Given token not valid for any token type" &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const response = await api.post("users/token/refresh/", {
            refresh: refreshToken.refresh,
          });
          const access_token = response.data.access;
          refreshToken.access = access_token
          let user = JSON.stringify(refreshToken)
          localStorage.setItem("user", user);
          return api(originalRequest);
        } catch (_error) {
          localStorage.removeItem("user")
          return Promise.reject(_error);
        }
      } else {
      }
    }
    return Promise.reject(error);
  }
);

export default api;
